module.exports = __webpack_public_path__ + "img/centerIonc2.65b0f989.png";